import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const SmartplanBarcharts = ({ Title, BarGraphData = [], onBarClick, className = "" }) => {
  const barWidth = 24; // slightly smaller to fit more space
  const customYTicks = [0, 10, 15, 20, 25, 30, 35, 40];

  const handleBarClick = (name) => {
    if (!onBarClick) return;

    if (name === "<$1M" || name === "$1M-$3M" || name === ">$3M") {
      const key = name === "<$1M" ? "less_than_1m" :
        name === "$1M-$3M" ? "between_1m_3m" : "greater_than_3m";
      onBarClick(key);
    } else if (name === "Buyer" || name === "Disposition") {
      const leadType = name === "Buyer" ? "acquisition" : "disposition";
      onBarClick(leadType);
    } else {
      const key = BarGraphData.find(item => item.name === name)?.key;
      if (key) {
        onBarClick(key);
      }
    }
  };

  const renderCustomBar = (props) => {
    const { x, y, width, height, fill, payload } = props;
    const color = payload.name === "sjhssh" ? "#2D5B30" : "#D1DBCF";
    return (
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={color}
        cursor="pointer"
        onClick={() => handleBarClick(payload.name)}
      />
    );
  };

  return (
    <div className={`light-bg-L h-full p-4 ${className}`}>
      <div className="flex justify-between mb-5">
        <h2 className="head-2 dark-H">{typeof Title === "string" ? Title : "Type of Lead"}</h2>
      </div>

      <ResponsiveContainer width="100%" height={220}> {/* slightly smaller height */}
        <BarChart
          className="dark-M body-S"
          data={BarGraphData}
          margin={{ top: 5, right: 20, left: 20, bottom: 5 }}
          barCategoryGap="30%" // less gap = stretch bars more
        >
          <CartesianGrid stroke="#efefef" vertical={false} />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
          />
          <YAxis
            tick={customYTicks}
            domain={[0, (dataMax) => Math.ceil(dataMax)]}
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => Number.isInteger(value) ? value : ''}
          />
          <Tooltip formatter={(value) => [`${value}`]} />
          <Bar
            dataKey="count"
            shape={renderCustomBar}
            barSize={barWidth}
            onClick={(data) => handleBarClick(data.name)}
            align="center"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SmartplanBarcharts;
